(function() { window.GUID_24c924f4_351d_4335_b1f9_c38a1cc733ff = { getGuid: function() { return "24c924f4-351d-4335-b1f9-c38a1cc733ff"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let BaseGameTypeId;
        (function (BaseGameTypeId) {
            BaseGameTypeId[BaseGameTypeId["General"] = 0] = "General";
            BaseGameTypeId[BaseGameTypeId["ScotchDouble"] = 3] = "ScotchDouble";
            BaseGameTypeId[BaseGameTypeId["ThreeHundredAndFirst"] = 4] = "ThreeHundredAndFirst";
            BaseGameTypeId[BaseGameTypeId["Cricket"] = 6] = "Cricket";
            BaseGameTypeId[BaseGameTypeId["Foosball"] = 9] = "Foosball";
            BaseGameTypeId[BaseGameTypeId["NONE"] = 10] = "NONE";
            BaseGameTypeId[BaseGameTypeId["Bocce"] = 11] = "Bocce";
            BaseGameTypeId[BaseGameTypeId["EightBall"] = 100] = "EightBall";
            BaseGameTypeId[BaseGameTypeId["NineBall"] = 101] = "NineBall";
            BaseGameTypeId[BaseGameTypeId["TenBall"] = 102] = "TenBall";
            BaseGameTypeId[BaseGameTypeId["Snooker"] = 103] = "Snooker";
        })(BaseGameTypeId = Enumeration.BaseGameTypeId || (Enumeration.BaseGameTypeId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=BaseGameTypeId.pre.js.map
